import cx from "classnames";
import React from "react";

type SectionProps = {
  children: React.ReactNode;
  className?: string;
  id?: string;
};

const Section: React.FC<SectionProps> = ({
  children,
  className,
  id,
}: SectionProps): React.ReactElement => (
  <div
    className={cx([
      "u-padding-bottom-xl",
      "u-padding-top-xl",
      className && className,
    ])}
    id={id}
  >
    {children}
  </div>
);

export default React.memo(Section);
